/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * @emails react-core
 */

import MarkdownPage from 'components/MarkdownPage';
import PropTypes from 'prop-types';
import React from 'react';
import {graphql} from 'gatsby';
import Layout from 'components/Layout';
import {createLinkLibri} from 'utils/createLink';
import {sectionListLibri} from 'utils/sectionList';
import VisitLibri from '../components/Apis/visit-libri';

const Libri = ({data, location}) => (
  <Layout location={location}>
    <VisitLibri />
    <MarkdownPage
      createLink={createLinkLibri}
      location={location}
      markdownRemark={data.markdownRemark}
      sectionList={sectionListLibri}
      titlePostfix=" &ndash; Milani"
    />
  </Layout>
);

Libri.propTypes = {
  data: PropTypes.object.isRequired,
};

export const pageQuery = graphql`
  query TemplateDocsMarkdown($slug: String!) {
    markdownRemark(fields: {slug: {eq: $slug}}) {
      html
      frontmatter {
        title
        next
        prev
      }
      fields {
        path
        slug
      }
    }
  }
`;

export default Libri;
